import { render, staticRenderFns } from "./shuidianguize.vue?vue&type=template&id=4968591d"
import script from "./shuidianguize.vue?vue&type=script&lang=js"
export * from "./shuidianguize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports